import { gql } from "@apollo/client";

/** Extra userReport fields required for the printable report view. */
export const USER_REPORT_PRINT_EXTENSION_FIELDS = gql`
  fragment UserReportPrintExtensionFields on UserReportType {
    displayOrderId
    dnaDatapointCounts {
      inRangeCount
      outOfRangeCount
      untestedCount
    }
    functionalDatapointCounts {
      inRangeCount
      outOfRangeCount
      untestedCount
    }
    questionsAndAnswersCounts {
      inRangeCount
      outOfRangeCount
      untestedCount
    }
    snpsForDiagram
    expectedSnps
    userResultConnections(first: 100) {
      edges {
        node {
          id
          dnaDatapointCounts {
            inRangeCount
            outOfRangeCount
            untestedCount
          }
          functionalDatapointCounts {
            inRangeCount
            outOfRangeCount
            untestedCount
          }
          symptomCounts {
            inRangeCount
            outOfRangeCount
            untestedCount
          }
          snpsForDiagram
          result {
            id
            name
            description
            diagram
          }
        }
      }
    }
  }
`;

/** Patient / subject details shown on the print cover page. */
export const PRINT_USER_PROFILE_FIELDS = gql`
  fragment PrintUserProfileFields on UserType {
    id
    firstName
    lastName
    patientProfile {
      id
      dateOfBirth
      gender
    }
  }
`;

/** Shared interpretation fields for per-result print pages. */
export const USER_RESULT_PRINT_CORE_FIELDS = gql`
  fragment UserResultPrintCoreFields on UserResultType {
    id
    expectedSnps
    questionsAndAnswers {
      id
      question {
        id
        symptomGroup
      }
      answerText
      answerScore
    }
    dnaDatapoints {
      id
      interpretation
      impactActivity
      riskAllele(useSnpValue: true)
      value
      snpInterpretation
      snpSuggestion
      datapoint {
        id
        name
      }
    }
    functionalDatapoints {
      id
      value
      sampleType
      dateExtracted
      chartConfiguration {
        interpretation
      }
      datapoint {
        id
        name
        units
        description
        function
        reason
      }
    }
  }
`;
